<template>
  <div>
    <form-navigation-tabs
      :tabs="tabs"
      v-on:selected="setActive"
      :active="currentView"
      :enable-logging="true"
      :incident="incident"
      :module="module"
      :parentTabs="['Claim Monitoring']"
      class="margin-t-10"
    ></form-navigation-tabs>

    <dates
      :incident="incident"
      :claimType="claimType"
      :readonly="readonly"
      v-show="currentView == 'dates'"
    ></dates>

    <template v-if="deployedServices['hire'] && incident && client">
      <hires
        :incident="incident"
        :client="client.identifier"
        :readonly="readonly"
        v-show="currentView == 'hire'"
      ></hires>
    </template>

    <template v-if="deployedServices['repair']">
      <repair
        :incident="incident"
        :selectedService="deployedServices['repair']"
        :readonly="readonly"
        v-show="currentView == 'repair'"
      ></repair>
    </template>

    <template v-if="deployedServices['salvage']">
      <salvage
        :incident="incident"
        :selectedService="deployedServices['salvage']"
        :readonly="readonly"
        v-show="currentView == 'salvage'"
      ></salvage>
    </template>

    <template v-if="deployedServices['recovery']">
      <recovery
        :incident="incident"
        :selectedService="deployedServices['recovery']"
        :readonly="readonly"
        v-show="currentView == 'recovery'"
      ></recovery>
    </template>

    <template v-if="deployedServices['diminution']">
      <diminution
        :incident="incident"
        :selectedService="deployedServices['diminution']"
        :readonly="readonly"
        v-show="currentView == 'diminution'"
      ></diminution>
    </template>

    <template v-if="deployedServices['personal_injury']">
      <personal-injury
        :incident="incident"
        :selectedService="deployedServices['personal_injury']"
        :readonly="readonly"
        v-show="currentView == 'personal_injury'"
      ></personal-injury>
    </template>
  </div>
</template>
<script>
import Dates from './Dates.vue';
import Hires from './Hires.vue';
import Repair from '@/components/Modules/Deployment/Repair';
import Salvage from '@/components/Modules/Deployment/Salvage';
import Recovery from '@/components/Modules/Deployment/Recovery';
import Diminution from '@/components/Modules/Deployment/Diminution';
import PersonalInjury from '@/components/Modules/Deployment/PersonalInjury.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    PersonalInjury,
    Dates,
    Hires,
    Repair,
    Salvage,
    Recovery,
    Diminution
  },

  data() {
    return {
      currentView: 'dates',
      tabs: [],
      deployedServices: {}
    };
  },

  computed: {
    claimType() {
      return this.$store.getters['Incident/claimType'];
    },

    client() {
      return this.$store.getters['Incident/client'];
    },

    services() {
      return this.$store.getters['Services/all'];
    },

    incidentServices() {
      return this.$store.getters['Incident/services'];
    }
  },

  mounted() {
    this.$store.commit('Services/retrieve');

    this.setTabs();
  },

  methods: {
    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;
      }
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    },

    setTabs() {
      this.deployedServices = {};

      const tabs = [
        {
          name: 'dates',
          label: 'Loss Of Use Dates'
        }
      ];

      const enabledServices = this.incidentServices.filter(
        service => service.enabled
      );

      this.services.forEach(service => {
        const deployedService = enabledServices.find(
          s => s.service_id === service.id
        );

        if (deployedService) {
          tabs.push({
            name: service.name,
            label: service.label
          });

          this.deployedServices[service.name] = deployedService;
        }
      });

      this.tabs = tabs;
    }
  },

  watch: {
    services() {
      this.setTabs();
    },

    incidentServices() {
      this.setTabs();
    }
  }
};
</script>
